/****
Main Javascript for UditiPrakashan
version: 3.0
****/
/*
Modified: 26-Apr-2023
*/

/*
Modified: 26-Apr-2023
*/
function EnforceLoggedUserOnly()
{
  if(appGlobal.USER_ID>0)
  {
    return true;
  }
  else {
    
  }
}

/*
Modified: 26-Apr-2023
*/
function ShowAuthMessage(templateName, element, rData)
{
  var tplMessage = Mustache.compile($(templateName).html());
  var data=new Object;

  data.message=rData.status_txt;
  data.nclass='';
  data.dismiss=0;

  if(rData.hasOwnProperty('data'))
  {
      data.data=rData.data;
  }

  if(rData.status_code==200)
  {
    data.nclass='';
    data.dismiss=0;
  }
  else
  {
    data.nclass='alert-danger';
    data.dismiss=1;
  }

  if(rData.hasOwnProperty('hide_form') && rData.hide_form==1)
  {
    element.closest('.core-auth-container').html(tplMessage(data));
  } else
  {
    element.closest('.core-auth-container').find('.core-auth-container-result').html(tplMessage(data));
  }
}

/*
Modified: 26-Apr-2023
*/
function EnableCoreAuthProcess()
{
  $("body").on("click", ".btn-core-auth-process", function(e) {
    e.preventDefault();
    var element=$(this);
    formId=element.data('form-id');
    ajaxPath=element.data('ajax-path');
    templateName=element.data('template-name');
    
    var urlHash = location.hash;
    
    var form = $(formId);
    if (form[0].checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
      debugData('Form invalid auth-process');
      form.addClass('was-validated');
    }
    else
    {
        form.addClass('was-validated');
        debugData('Form valid auth-process');
        $.ajax({
            url: appGlobal.AJAX_URL + 'app-auth/' + ajaxPath,
            dataType: "json",
            data: $(formId).serialize(),
            type: 'post',
            success: function(rData) {
              debugData('Ajax Success');
              debugData(rData);
              if(rData!=null && rData.hasOwnProperty('status_txt'))
              {
                if(rData.hasOwnProperty('status_code') && rData.status_code==200)
                {
                    ShowAuthMessage(templateName, element, rData);
                    if(rData.hasOwnProperty('is_go_url') && rData.is_go_url==1)
                    {
                        var redirectUrl='';
                        if(rData.hasOwnProperty('go_url'))
                        {
                            redirectUrl=rData.go_url;
                        }
                        else {
                            var tempUrl=$(location).attr('href');
                            
                            if (tempUrl.indexOf("https://") == -1) { 
                        		tempUrl = tempUrl.replace("http://", "https://"); 
                      		} 
                            redirectUrl=tempUrl;
                        }
                        if (redirectUrl.indexOf("#") == -1) {
                            redirectUrl=redirectUrl+urlHash;
                        }
                        debugData(redirectUrl);
                        LoadUrl(redirectUrl);
                    }
                }
                else {
                  ShowAuthMessage('#tpl-core-generic-message', element, rData);
                }
              }
              else {
                  var newData= new Object;
                  newData.status_txt='Error processing your request';
                  newData.status_code=203;
                  ShowAuthMessage('#tpl-core-generic-message', element, newData);
              }
            }
        })
    }
    
    });
}

/*
Modified: 26-Apr-2023
*/
function EnableSharing() {
    $("body").on("click", ".ua-share-url-social", function() {
        var element = $(this),
          parentid=element.data('parentid'),
          parent=$('#'+parentid),
          social_type = element.data("type"),
          oid = element.data("oid"),
          url = parent.data("url"),
          txt = parent.data("txt"),
          logData= new Object;
          logData.oid=oid,
          logData.url=url,
          logData.txt=txt,
          logData.social_type=social_type;
          if(appGlobal.IS_MOBILE==0)
          {
            if(social_type==3)
                social_type==30;
            if(social_type==4)
                social_type==40;    
          }
          SaveLogData('url-share-social', logData);
          ShareSocial(social_type, url);
    });
}

/*
Modified: 26-Apr-2023
*/
function EnableBasicAjax()
{
    $(document).on("click", ".btn-ajax-form-submit", function(e){
        e.preventDefault();
        var jsCodeId='btn-ajax-form-submit';
        debugData('---'+jsCodeId+'---');

        var self=$(this);

        var formId='#'+self.attr('data-form-id');
        var ajaxUrl=self.attr('data-action-url');
        var redirectUrl=self.attr('data-redirect-url');
        var redirectDelay=self.attr('data-redirect-delay');
        var redirectionEnabled=self.attr('data-redirection-enabled');
        var resultInline=self.attr('data-result-inline');
        var resultContainer=self.attr('data-result-container');
        var mainContainer=self.attr('data-main-container');
        var tplName=self.attr('data-template-name');
        var form = $(formId);
      
        if (form[0].checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          
        }
        form.addClass('was-validated');
        debugData(appGlobal.AJAX_URL+ajaxUrl);
        if (form[0].checkValidity())
        {
            debugData($(formId).serialize());
            $.ajax({
                url: appGlobal.AJAX_URL+ajaxUrl,
                type: 'post',
                data: $(formId).serialize(),
                dataType: "json",
                success: function(rData) {
                    debugData(rData);
                    if(rData!=null && rData.hasOwnProperty('status_code') && rData.status_code==200)
                    {
                        if(rData.hasOwnProperty('status_txt'))
                            ShowAlert(rData.status_txt, 1);
                        else
                            ShowAlert(self.attr('data-error-content'), 2);

                        if("" !== resultInline && "undefined" != typeof resultInline && resultInline=="yes")
                        {
                            debugData('result inline');
                            var tplMessage = Mustache.compile($(tplName).html());
    						$(mainContainer).fadeOut(400, function() {
    							$(resultContainer).fadeIn();    
    						});
    						$(resultContainer).html(tplMessage(rData));
                        }

                        if(redirectionEnabled=='yes')
                        {
							if(rData.hasOwnProperty('redirect_url'))
							{
								debugData(rData.redirect_url);
								LoadUrl(rData.redirect_url, redirectDelay);
							}
							else
							{
								debugData(redirectUrl);
								LoadUrl(redirectUrl, redirectDelay);
							}
                        }
                    }
                    else
                    {
                        if(rData.hasOwnProperty('status_txt'))
                            ShowAlert(rData.status_txt, 2);
                        else
                            ShowAlert(self.attr('data-error-content'), 2);
                    }
                }
            });
        }
        debugData('---/'+jsCodeId+'---');
    });
    $(document).on("click", ".btn-edit-object", function(e){
        e.preventDefault();
        var jsCodeId='btn-edit-object';
        debugData('---'+jsCodeId+'---');
        var self=$(this);
        var tplName=self.attr('data-template-name');
		var ajaxUrl=self.attr('data-action-url');
		var objectId=self.attr('data-object-id');
		var containerId=self.attr('data-container-main');
		var containerViewId=self.attr('data-container-view');
		        
		$.ajax({
                url: appGlobal.AJAX_URL+ajaxUrl,
                type: 'post',
                data: 'oid='+objectId,
                dataType: "json",
                success: function(rData) {
                    debugData(rData);
                    if(rData!=null && rData.hasOwnProperty('status_code') && rData.hasOwnProperty('data') && rData.status_code==200)
                    {
                        var tplMessage = Mustache.compile($(tplName).html());
						$(containerId).fadeOut(400, function() {
							$(containerViewId).fadeIn();    
						});
						$(containerViewId).html(tplMessage(rData.data));
                    }
                    else
                    { 
                        if(rData.hasOwnProperty('status_txt'))
                            ShowAlert(rData.status_txt, 2);
                        else
                            ShowAlert(self.attr('data-error-content'), 2);
                    }                              
                }
            }); 
            debugData('---/'+jsCodeId+'---');
    });
    $(document).on("click", ".btn-cancel-edit-object", function(e){
        e.preventDefault();
        var jsCodeId='btn-cancel-edit-object';
        debugData('---'+jsCodeId+'---');
        var self=$(this);		
		var containerId=self.attr('data-container-main');
		var containerViewId=self.attr('data-container-view');		
        $(containerViewId).fadeOut(400, function() {
            $(containerId).fadeIn(400, function() {
                $(containerViewId).html(''); 
            });    
        });
        debugData('---/'+jsCodeId+'---');
    });
    $(document).on("click", ".btn-close-collapse", function(e){
        e.preventDefault();
        var jsCodeId='btn-close-collapse';
        debugData('---'+jsCodeId+'---');
        var self=$(this);
		var containerId=self.attr('data-target-collapse');
        $(containerId).collapse('hide');
        debugData('---/'+jsCodeId+'---');
    });
}

/*
Modified: 26-Apr-2023
*/
function EnableEcommerce()
{
  $("body").on("click", ".ecom-add-to-cart", function(e) {
    e.preventDefault();
    var element=$(this);
    objectId=element.data('oid');
    goCart=element.data('go-cart');
    ajaxPath='ecommerce/cart/add-object/';
    cartCountCt="#ecom-cart-count";
    
    $(element).button('toggle');
    debugData('Ecommerce: Add to Cart');
    $.ajax({
        url: appGlobal.AJAX_URL + ajaxPath,
        dataType: "json",
        data: 'oid='+objectId,
        type: 'post',
        success: function(rData) {
          debugData('Ajax Success');
          debugData(rData);
          $(element).button('reset');
          if(rData!=null && rData.hasOwnProperty('status_txt'))
          {
            if(rData.hasOwnProperty('status_code') && rData.status_code==200)
            {
                ShowAlert(rData.status_txt, 1);
                if(goCart==1)
                {
                    var redirectUrl=appGlobal.WEB_URL+'cart/';
                    debugData(redirectUrl);
                    LoadUrl(redirectUrl);
                }
                else
                {
                    $(cartCountCt).text(rData.cart_count);
                }
            }
            else {
                ShowAlert(rData.status_txt, 2);
            }
          }
          else {
                $(element).button('reset');
                ShowAlert('Error processing your request', 2);
          }
        }
    })
  });
}

/*
Modified: 26-Apr-2023
*/
function EnableSearchBar()
{
    if($('#input-srch-octo-topt').length>0)
    {
        var input = document.getElementById('input-srch-octo-topt');
        input.oninvalid = function(event) {
            event.target.setCustomValidity('Please enter minimum 3 characters to search');
        }    
    }
    
    if($('#input-srch-octo-topb').length>0)
    {
        var input = document.getElementById('input-srch-octo-topb');
        input.oninvalid = function(event) {
            event.target.setCustomValidity('Please enter minimum 3 characters to search');
        }    
    }
}

/*
Modified: 26-Apr-2023
*/
function LoadUrl(url)
{
  var redirect_delay=1;
  if (navigator.userAgent.match(/MSIE\s(?!9.0)/)) {
            var referLink = document.createElement('a');
            referLink.href = url;
            document.body.appendChild(referLink);
            //referLink.click();
			window.setTimeout(function(){referLink.click()}, (redirect_delay*1000));
        }
        // All other browsers
        else {
			window.setTimeout(function(){window.location.replace(url)}, (redirect_delay*1000));
		}
}

/*
Modified: 26-Apr-2023
*/
function InitJqueryAjax()
{
  $( document ).ajaxError(function( event, request, settings, error ) {
    debugData('Ajax Error');
    debugData("Error requesting page " + settings.url);
    debugData(error);
    debugData(request.responseText);
    ShowAlert('Our engineers have been notified about this error', 2, 'App Error');
  });
  
  $( document ).ajaxStart(function() {
      console.log( "Triggered ajaxStart handler." );
      $('#kartooz-page-loader').fadeIn(300);
    });
  
  $( document ).ajaxComplete(function() {
      console.log( "Triggered ajaxStop handler." );
      $('#kartooz-page-loader').fadeOut(800);
    });
}

/*
Modified: 26-Apr-2023
*/
function SaveLogData(ajaxPath, logData) {
    $.ajax({
        url: appGlobal.AJAX_URL + 'app-utils/save-log/' + ajaxPath + '/',
        dataType: "json",
        data: $.param(logData),
        type: 'post',
        async: true
    });
}

/*
Modified: 26-Apr-2023
*/
function closeCollapse(e) {
    $(e.data('target')).collapse('hide');
}


/*
Modified: 26-Apr-2023
type: 0=normal, 1=success, 2=error
*/
function ShowAlert(message, type, title) {    
    var alertId=Math.ceil(Math.random() * 1000)+'-'+type+'-'+Math.ceil(Math.random() * 10000);
    var tplMessage = Mustache.compile($('#tpl-core-toast-message').html());
    alertData= new Object;
    alertData.id=alertId;
    alertData.has_text=0;
    if("undefined" !== typeof title && null !== title && "" !== title)
    {
        alertData.title=title;
        alertData.op_title=1;
        alertData.has_text=1;
    }
    if("undefined" !== typeof message && null !== message && "" !== message)
    {
        alertData.message=message;
        alertData.op_msg=1;
        alertData.has_text=1;
    }
    if(alertData.has_text==0)
    {
        alertData.title='App Error';
        alertData.op_title=1;
    }
    if(type==2)
    {
        alertData.css_bg='bg-danger';
        alertData.css_txt='text-danger';
    }
    else if(type==1)
    {
        alertData.css_bg='bg-success';
        alertData.css_txt='text-success';
    }
    else
    {
        alertData.css_bg='bg-dark';
        alertData.css_txt='text-dark';
    }
    debugData('ShowAlert');
    debugData(alertData);
    $('#kartooz-toasts-container').append(tplMessage(alertData));
    $('#'+alertId+'-kartooz-toast').toast('show');
}

/*
Modified: 26-Apr-2023
*/
function RemoveAlert() {
    $(".notify-alert").remove()
}

function debugData(data)
{
  if(appGlobal.APP_DEBUG==1)
    console.log(data);
}

/*
Modified: 26-Apr-2023
*/
function LoadStyleSheet(src) {
    if (document.createStyleSheet){
        document.createStyleSheet(src);
    }
    else {
        $("head").append($('<link rel="stylesheet" crossorigin="anonymous" href="'+src+'" type="text/css" media="screen" />'));
    }
};

/* /Non initialized functions */
/*
Modified: 26-Apr-2023
*/
function ShareSocial(social_type, url) {
  var wd = 500,
    ht = 600,
    s_left = void 0 != window.screenLeft ? window.screenLeft : screen.left,
    s_top = void 0 != window.screenTop ? window.screenTop : screen.top,
    w_wd = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
    w_ht = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
    left = w_wd / 2 - wd / 2 + s_left,
    top = w_ht / 2 - ht / 2 + s_top;

  return 1 == social_type ? (window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url), "Facebook Share", "scrollbars=yes, width=" + wd + ", height=" + ht + ", top=" + top + ", left=" + left), !1) : 2 == social_type ? (window.open("https://twitter.com/share?url=" + encodeURIComponent(url), "Twitter Share", "scrollbars=yes, width=" + wd + ", height=" + ht + ", top=" + top + ", left=" + left), !1) : 3 == social_type ? (window.location.href='whatsapp://send?text=' + encodeURIComponent(url), !1) : 30 == social_type ? (window.open='https://wa.me/?text=' + encodeURIComponent(url), !1) : (window.location.href='tg://msg?text=' + encodeURIComponent(url))
}

/*
Modified: 26-Apr-2023
*/
(jQuery, window, document), $(function() {
    
    if($("img.lazy").length>0){
      $("img.lazy").Lazy({
          delay: 300
      });
    }

    debugData("jQuery is ready");
}),
$(document).ready(function(){
          
    $('#kartooz-page-loader').fadeOut(800);      
      $("body").on("click", ".close-alert", function() {
        RemoveAlert()
      })
      ;

      InitJqueryAjax(),  EnableCoreAuthProcess(), EnableSharing(), EnableBasicAjax(), EnableEcommerce()
});